/**
 * Keeps overlay scroll restoration instant.
 *
 * `html { scroll-behavior: smooth }` (base.css, and stock Horizon) applies to
 * every programmatic scroll, including the ones libraries perform internally to
 * put you back where you were after a modal closes.
 *
 * Overlays that lock the page do it by pinning the body:
 *
 *   body { position: fixed; top: -<scrollY>px; overflow: hidden }
 *
 * which parks the document at 0. On close they clear that and scroll back. With
 * smooth scrolling active, that restore is animated — so closing a Judge.me
 * review photo sent the page gliding from the top all the way back down.
 * Measured on a product page: 77 intermediate positions over ~1.8s of visible
 * travel, versus 2 positions and no travel once the restore is instant.
 *
 * The lock itself is the signal, so this covers any library using that pattern
 * (Judge.me's Magnific Popup today) rather than naming one. Smooth scrolling is
 * only suspended while such an overlay is open and for a moment afterwards, so
 * anchor links and deliberate `behavior: 'smooth'` calls are untouched.
 */
(function () {
  var locked = false;
  var releaseTimer = null;

  /** Milliseconds to stay instant after the lock clears, covering the restore. */
  var RESTORE_WINDOW = 400;

  function sync() {
    // Resolved per call rather than captured up front: this file may be
    // evaluated before the document element exists.
    var root = document.documentElement;
    var isLocked = document.body.style.position === 'fixed';

    if (isLocked && !locked) {
      locked = true;
      clearTimeout(releaseTimer);
      root.style.scrollBehavior = 'auto';
      return;
    }

    if (!isLocked && locked) {
      locked = false;
      // The close handler clears the lock and scrolls back in the same
      // synchronous block, so we are already too late to react to it — the
      // hold above is what makes the restore instant. Hand smooth scrolling
      // back once that has settled.
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(function () {
        document.documentElement.style.scrollBehavior = '';
      }, RESTORE_WINDOW);
    }
  }

  function start() {
    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
